import type {
  PartitionFormat,
  PartitionSegmentType,
  PathSegment,
} from '@repo/api-gw-sdk';
import { FileFormat, IngestionSourceType, SegmentType } from '@repo/api-gw-sdk';

export type { PartitionSegmentType, PartitionFormat };
export { SegmentType };

export interface PathSegmentState {
  id: string;
  segmentType: SegmentType;
  segmentStringValue: string;
  segmentPartitionName: string;
  segmentPartitionType: PartitionSegmentType;
  segmentPartitionFormat: PartitionFormat;
}

export interface IngestionPipelineWizardState {
  // Step 1: Pipeline Details
  name: string;
  namespace: string;
  tableName: string;

  // Step 2: Source Configuration
  sourceType: IngestionSourceType;
  // S3 fields
  s3Bucket: string;
  s3Region: string;
  s3OwnerAccountId: string;
  // GCS fields
  gcsBucket: string;
  gcsProjectId: string;
  gcsLocation: string;
  // Shared
  fileFormat: FileFormat;

  // Step 3: Partitioning
  partitionSpec: {
    separator: string;
    segments: PathSegmentState[];
  };

  // UI state
  partitionBuilderMode: 'build' | 'paste';
  samplePath: string;

  // Update mode — controls button text and success message in ReviewStep
  isUpdateMode: boolean;
}

export const defaultWizardState: IngestionPipelineWizardState = {
  // Step 1
  name: '',
  namespace: '',
  tableName: '',

  // Step 2
  sourceType: IngestionSourceType.INGESTION_SOURCE_TYPE_S3,
  s3Bucket: '',
  s3Region: '',
  s3OwnerAccountId: '',
  gcsBucket: '',
  gcsProjectId: '',
  gcsLocation: '',
  fileFormat: FileFormat.FILE_FORMAT_JSON,

  // Step 3
  partitionSpec: {
    separator: '/',
    segments: [],
  },

  // UI state
  partitionBuilderMode: 'build',
  samplePath: '',

  isUpdateMode: false,
};

export const mapSegments = (segments: PathSegmentState[]): PathSegment[] =>
  segments.map((seg) => ({
    segmentType: seg.segmentType,
    ...(seg.segmentType === SegmentType.SEGMENT_TYPE_STRING && {
      segmentStringValue: seg.segmentStringValue || undefined,
    }),
    ...(seg.segmentType === SegmentType.SEGMENT_TYPE_PARTITION && {
      segmentPartitionName: seg.segmentPartitionName || undefined,
      segmentPartitionType: seg.segmentPartitionType || undefined,
      segmentPartitionFormat: seg.segmentPartitionFormat || undefined,
    }),
  }));
